<template>
	<div id="quillEditorId">
		<el-upload class="avatarUploader" action="aaa" :http-request="upLoad" :show-file-list="false" list-type="picture-card">
			<i class="el-icon-plus avatar-uploader-icon" id="quillId"></i>
		</el-upload>
		<quill-editor id="myQuillEditorId" ref="myQuillEditor" v-model="editeContent" :options="editorOption" @change="handelEditorChange($event)"></quill-editor>
	</div>
</template>

<script>
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
const uploadConfig = {
  // action:  'https://www.lumingtec.cn/Business/serviceInterface/fileUpload.json',  // 必填参数 图片上传地址
  methods: 'POST', // 必填参数 图片上传方式
  token: '', // 可选参数 如果需要token验证，假设你的token有存放在sessionStorage
  name: 'file', // 必填参数 文件的参数名
  size: 700, // 可选参数   图片大小，单位为Kb, 1M = 1024Kb
  accept: 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon', // 可选 可上传的图片格式
  type:'audio/mp4,video/mp4'
}
const toolbarOptions = [
	['bold', 'italic', 'underline', 'strike'], //加粗，斜体，下划线，删除线
	['blockquote', 'code-block'], //引用、代码块儿
	[{ header: 1 }, { header: 2 }], //标题，键值对的形式；1、2表示字体大小
	[{ list: 'ordered' }, { list: 'bullet' }], //列表
	[{ script: 'sub' }, { script: 'super' }], //上下标
	[{ indent: '-1' }, { indent: '+1' }], //缩进
	[{ direction: 'rtl' }], //文本方向
	[{ size: ['small', false, 'large', 'huge'] }], //字体大小
	[{ header: [1, 2, 3, 4, 5, 6, false] }], //几级标题
	[{ color: [] }, { background: [] }], //字体颜色，字体背景颜色
	[{ font: [] }], //字体
	[{ align: [] }], //对齐方式
	['clean'], //清除字体样式
	['image','video'] //上传图片(image)、上传视频(video)、超链接(link)
];
export default {
	name: 'editor',
	components: { quillEditor },

	data() {
		return {
			dialogImageUrl: '',
			editeContent: '',
			editorOption: {
				modules: {
					clipboard: {
						// 粘贴版，处理粘贴时候的自带样式
						matchers: [[Node.ELEMENT_NODE, this.HandleCustomMatcher]]
					},
					toolbar: {
						container: toolbarOptions, // 工具栏
						handlers: {
							//配置上传图片（自定义）
							image: function(value) {
								if (value) {
									// 获取隐藏的上传图片的class，不一定是.el-icon-plus。触发上传图片事件
									document.querySelector('#quillId').click();
								} else {
									this.quill.format('image', false);
								}
							},
							//配置上传视频（自定义）
							video: function() {
								// var self = this
								var fileInput = this.container.querySelector('input.ql-video[type=file]');
								if (fileInput === null) {
									fileInput = document.createElement('input');
									fileInput.setAttribute('type', 'file');
									if (uploadConfig.name) {
										fileInput.setAttribute('name', uploadConfig.name);
									}
									fileInput.setAttribute('accept', uploadConfig.type);
									fileInput.classList.add('ql-video');
									fileInput.addEventListener('change', function() {
										// var formData = new FormData();
										// formData.append(uploadConfig.name, fileInput.files[0]);
										// if (uploadConfig.token) {
										// 	formData.append('token', uploadConfig.token);
										// }
										// fileUpload(formData).then(response => {
										//   window.console.log('upload response:', response)
										//   let url = 'https://www.lumingtec.cn/Business/file/' + response.fileName
										//   self.quill.insertEmbed(length, 'video',url)
										// })
									});

									this.container.appendChild(fileInput);
								}
								fileInput.click();
							}
						}
					}
				},
				placeholder: ''
			}
		};
	},
	methods: {
		upLoad(data) {
			// 思路：上传图片至服务后，拿到返回的图片地址。直接创建image标签插入光标所在的位置
			// 图片上传服务(本地服务或者阿里云服务)
			// 获取富文本组件实例
			const formData = new FormData();
			formData.append('file', data.file);
			formData.append('path', 'news');
			this.$post('/file/upload', formData)
				.then(res => res.data)
				.then(data => {
					if (data.code == 0) {
						this.dialogImageUrl = this.$Url + data.data;
						let quill = this.$refs.myQuillEditor.quill;
						// 上传服务成功后，按根据光标位置把图片插入编辑器中
						if (this.dialogImageUrl) {
							// 获取光标所在位置,data.url表示上传服务后返回的图片地址
							let length = quill.getSelection().index;
							// 插入图片，data.url为服务返回的图片链接地址
							quill.insertEmbed(length, 'image', this.dialogImageUrl);
							// 调整光标到最后
							quill.setSelection(length + 1);
						} else {
							this.$message.closeAll();
							this.$message.error('图片插入失败');
						}
					}
				});
		},
		//富文本内容
		handelEditorChange(el) {
			window.console.log(el);
			// this.editeContent=el
			// window.console.log(this.editeContent)
		},
		HandleCustomMatcher(node, Delta) {
			// 文字、图片等，从别处复制而来，清除自带样式，转为纯文本

			return Delta;
		}
	}
};
</script>

<style>
#quillEditorId .avatarUploader {
	display: none;
}
input.ql-video{
	display: none;
}
</style>
